import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../../../services/wrapper-http-service';
import { HubEndpoint } from '../../../constants/hub-endpoint';
import { API_URL } from '../../../../../../../services/config';
import { HubLoanerPhoneListItem } from '../../../models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HubLoanerPhoneItemService {
  constructor(private http: WrapperHttpService) {}

  getLoanerPhoneItem(hubId: number, id: number): Observable<HubLoanerPhoneListItem> {
    const url = `${API_URL}${HubEndpoint.Base}/${hubId}${HubEndpoint.LoanerPhones}/${id}`;

    return this.http.withLoading().get<HubLoanerPhoneListItem>(url);
  }

  returnLoanerPhoneItem(hubId: number, id: number, returnTimestamp: number): Observable<HubLoanerPhoneListItem> {
    const url =
      `${API_URL}${HubEndpoint.Base}/${hubId}${HubEndpoint.LoanerPhones}/${id}${HubEndpoint.Return}?returnTimestamp=` +
      returnTimestamp;

    return this.http.withLoading().post<HubLoanerPhoneListItem>(url, {});
  }

  createLoanerPhoneItem(hubId: number, loanerPhoneItem: HubLoanerPhoneListItem): Observable<HubLoanerPhoneListItem> {
    const url = `${API_URL}${HubEndpoint.Base}/${hubId}${HubEndpoint.LoanerPhones}`;

    return this.http.withLoading().post<HubLoanerPhoneListItem>(url, loanerPhoneItem);
  }

  updateLoanerPhoneItem(hubId: number, loanerPhoneItem: HubLoanerPhoneListItem): Observable<HubLoanerPhoneListItem> {
    const url = `${API_URL}${HubEndpoint.Base}/${hubId}${HubEndpoint.LoanerPhones}`;

    return this.http.withLoading().post<HubLoanerPhoneListItem>(url, loanerPhoneItem);
  }

  deleteLoanerPhoneItem(hubId: number, id: number): Observable<HubLoanerPhoneListItem> {
    const url = `${API_URL}${HubEndpoint.Base}/${hubId}${HubEndpoint.LoanerPhones}/${id}`;

    return this.http.withLoading().delete<HubLoanerPhoneListItem>(url);
  }
}
